import React, {useEffect, useState} from 'react';
import {Container, Form, Col, Row} from 'react-bootstrap';
import {useForm} from 'react-hook-form/dist/react-hook-form.ie11';
import PropTypes from 'prop-types';
import {object, string} from 'yup';
import moment from 'moment';
import {TextInput, SelectInput, StyledRadioInput} from '../../../Helpers/Inputs';
import NotesPagesNotification from '../../../../icons/NotesPagesNotification.svg';
import {InputMaskDate, InputMaskPhone } from '../../../Helpers/Formatters';
import States from '../../../Helpers/Lists/States';
import { GenderOptions, MaritalStatusOptions, TobaccoOptions } from '../../../Common/Constant';
import TitleComponent from '../../../Common/TitleComponent';
import BackNextButton from '../../../Common/BackNextButton';
import { customValidators } from '../../../Helpers/Validators/customValidators';
import { InsuredRelationshipWithOwnerOptions } from '../../../Helpers/Lists/InsuredRelationshipWithOwnerOptions';
import { PrefillCreateCaseInsuredInfo } from './SubComponents/PrefillCreateCaseInsuredInfo';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../../sessionStorage';

export default function InsuredBasicInfo(props) {

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const isMSEnableRelationshipToOwner = accountObj && accountObj.msEnableRelationshipToOwner;
  let fullForm = { ...props.fullFormState };
  const retrieveAccount = fullForm && fullForm.pages && fullForm.pages.retrieveAccount;
  const isProspectType = retrieveAccount && retrieveAccount.clientType === "Prospect";
  const isProposedInsured = retrieveAccount && retrieveAccount.isProposedInsured;
  const isSurvivorshipPolicy = props.isSurvivorshipPolicy;
  const isPrimaryInsuredOther = props.formState.isOther;
  const isSecondaryInsuredOther = props.formState.isSecondaryInsuredOther;
  const isShowProposedInsuredEmailAndPhone = (((isProposedInsured === 'false' || isProposedInsured === '' ) && !isSurvivorshipPolicy)|| (isSurvivorshipPolicy && isPrimaryInsuredOther)) && !isProspectType;
  const {register, errors, handleSubmit, setValue, triggerValidation} = useForm({
    validationSchema: InsuredBasicInfo.ValidationSchema(props.ageSpecs, isShowProposedInsuredEmailAndPhone, isSurvivorshipPolicy, isMSEnableRelationshipToOwner),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const [isPIFirstNameDisabled, setIsPIFirstNameDisabled] = useState(false);
  const [isPIMiddleInitialDisabled, setIsPIMiddleInitialDisabled] = useState(false);
  const [isPILastNameDisabled, setIsPILastNameDisabled] = useState(false);
  const [isDOBDisabled, setIsDOBDisabled] = useState(false);
  const [isStateDisabled, setIsStateDisabled] = useState(false);
  const [isGenderDisabled, setIsGenderDisabled] = useState(false);
  const [isPIEmailDisabled, setIsPIEmailDisabled] = useState(false);
  const [isPIPhoneDisabled, setIsPIPhoneDisabled] = useState(false);
  const [isInsuredRelationshipWithOwnerDisabled, setIsInsuredRelationshipWithOwnerDisabled] = useState(false);
  const listOfFields = ['proposedInsuredFirstName', 'proposedInsuredMiddleInitial', 'proposedInsuredLastName', 'gender', 'birthdate', 'maritalStatus', 'tobacco', 'state', 'proposedInsuredEmail', 'proposedInsuredPhone', 'insuredRelationshipWithOwner', 'isOther', 'secondaryInsuredFirstName', 'secondaryInsuredMiddleInitial', 'secondaryInsuredLastName', 'secondaryInsuredGender', 'secondaryInsuredBirthdate', 'secondaryInsuredState', 'secondaryInsuredMaritalStatus', 'secondaryInsuredTobacco', 'secondaryInsuredEmail', 'secondaryInsuredPhone', 'secondaryInsuredRelationshipWithOwner', 'isSecondaryInsuredOther'];

  useEffect(() => {
    listOfFields.forEach((field) => {
      register({ name: field });
      setValue(field, props.formState[field]);
    })
  }, [register]);

  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };

  useEffect(() => {
    window.scrollTo(0, 0);  
    const data = fullForm.pages.retrieveAccount && fullForm.pages.retrieveAccount.ownerDetails;
    const isSavedQuote = fullForm.pages.retrieveAccount.isSavedQuote;
    const stringOfDob = data && data.dateOfBirth ? moment(data.dateOfBirth).format('MM/DD/YYYY') : '';
    const email = Object.keys(data).filter(x => x.toLowerCase().includes('email') && data[x]);
    const phone = Object.keys(data).filter(x => x.toLowerCase().includes('phone') && data[x]);

    const handleSetValueAndDisableTheField = (field, value, setValueFn, disableFn) => {
      fullForm.pages.insuredBasicInfo[field] = value;
      setValueFn(field, value);
      disableFn(true);
    }

    //Reset the input field if the value is empty.
    const handleResetWithDefaultValue = (condition, field, defaultValue, setValueFn, disableFn) => {
      if (condition && isProposedInsured !== '') {
        setValueFn(field, defaultValue);
        fullForm.pages.insuredBasicInfo[field] = defaultValue;
        disableFn(false);
      }
    }

    const handlePopulateProposedInsured = () => {
      if (isProposedInsured === 'true') {
        handleSetValueAndDisableTheField('proposedInsuredFirstName', data.firstName, setValue, setIsPIFirstNameDisabled);
        handleSetValueAndDisableTheField('proposedInsuredLastName', data.lastName, setValue, setIsPILastNameDisabled);

        if (data.middleName) {
          handleSetValueAndDisableTheField('proposedInsuredMiddleInitial', data.middleName, setValue, setIsPIMiddleInitialDisabled);
        } else {
          fullForm.pages.insuredBasicInfo.proposedInsuredMiddleInitial = props.formState.proposedInsuredMiddleInitial;
          setValue('proposedInsuredMiddleInitial', props.formState.proposedInsuredMiddleInitial);
          setIsPIMiddleInitialDisabled(false);
        }

        handleSetValueAndDisableTheField('proposedInsuredEmail', data.email, setValue, setIsPIEmailDisabled);
        handleSetValueAndDisableTheField('proposedInsuredPhone', data.phone, setValue, setIsPIPhoneDisabled);
        {isMSEnableRelationshipToOwner && handleSetValueAndDisableTheField('insuredRelationshipWithOwner', 'Self', setValue, setIsInsuredRelationshipWithOwnerDisabled);}
        fullForm.pages.insuredBasicInfo.isOther = false;
      }

      if (isProposedInsured === 'true' && isSavedQuote !== 'true') {
        handleSetValueAndDisableTheField('birthdate', stringOfDob, setValue, setIsDOBDisabled);
        handleSetValueAndDisableTheField('gender', data.gender, setValue, setIsGenderDisabled);
        handleSetValueAndDisableTheField('state', data.state, setValue, setIsStateDisabled);
      }
    }

    if (Object.keys(data).length !== 0 && !isSurvivorshipPolicy) {
      handlePopulateProposedInsured();

      handleResetWithDefaultValue(!data.firstName, 'proposedInsuredFirstName', '', setValue, setIsPIFirstNameDisabled);
      handleResetWithDefaultValue(!data.lastName, 'proposedInsuredLastName', '', setValue, setIsPILastNameDisabled);
      handleResetWithDefaultValue(email.length <= 0, 'proposedInsuredEmail', '', setValue, setIsPIEmailDisabled);
      handleResetWithDefaultValue(phone.length <= 0, 'proposedInsuredPhone', '', setValue, setIsPIPhoneDisabled);

      if (isSavedQuote !== 'true') {
        handleResetWithDefaultValue(!data.dateOfBirth, 'birthdate', '', setValue, setIsDOBDisabled);
        handleResetWithDefaultValue(!data.gender, 'gender', props.formState.gender, setValue, setIsGenderDisabled);
        handleResetWithDefaultValue(!data.state, 'state', '', setValue, setIsStateDisabled);
      }
      props.onMultiFieldChange(fullForm);
    }

    if (isSurvivorshipPolicy) {
      PrefillCreateCaseInsuredInfo(fullForm, setValue, listOfFields, props.formState.isOther, props.formState.isSecondaryInsuredOther, isMSEnableRelationshipToOwner);
      props.onMultiFieldChange(fullForm);
    }
  }, []);

  const renderTextInput = (name, label, value, disabled = false, inputMask = null) =>
    <TextInput
      name={name}
      id={name}
      label={label}
      value={value}
      onChange={e => handleValueChange(name, e.target.value)}
      errors={errors && errors[name]}
      inputRef={register}
      disabled={disabled}
      InputProps={inputMask !== null ? {
        inputComponent: inputMask,
      } : {}}
    />

  const renderRadioInput = (name, options, value, label, disabled = false,) =>
    <StyledRadioInput
      name={name}
      id={name}
      label={label}
      inputRef={register}
      value={value}
      options={options}
      onChange={e => handleValueChange(name, e)}
      disabled={disabled}
      errors={errors && errors[name]}
    />

  const renderSelectInput = (name, label, value, selectOptions, hideEmptyOption = false, disabled = false) => {
    return (
      <SelectInput
        name={name}
        id={name}
        value={value}
        onChange={(e) => handleValueChange(name, e.target.value)}
        label={label}
        selectOptions={selectOptions}
        errors={errors && errors[name]}
        inputRef={register}
        hideEmptyOption={hideEmptyOption}
        disabled={disabled}
      />
    )
  }

  return (
    <Container fluid className='border-class'>
      <form className="mt-3" onSubmit={handleSubmit(props.onNext)}>
        <Row className="justify-content-center pt-4">
          <Col lg={4}>
            <TitleComponent icon={NotesPagesNotification} title={`Proposed Insured ${isSurvivorshipPolicy ? '1' : ''} Information`} />
            <Form.Group>
              {renderTextInput('proposedInsuredFirstName', 'First Name', props.formState.proposedInsuredFirstName, isPIFirstNameDisabled || !isPrimaryInsuredOther)}
            </Form.Group>
            <Form.Group>
              {renderTextInput('proposedInsuredMiddleInitial', 'Middle Initial', props.formState.proposedInsuredMiddleInitial, isPIMiddleInitialDisabled || props.formState.proposedInsuredMiddleNameDisabled)}
            </Form.Group>
            <Form.Group>
              {renderTextInput('proposedInsuredLastName', 'Last Name', props.formState.proposedInsuredLastName, isPILastNameDisabled || !isPrimaryInsuredOther)}
            </Form.Group>
            <Form.Group className="mb-1">
              {renderRadioInput('gender', GenderOptions, props.formState.gender, '', isGenderDisabled || !isPrimaryInsuredOther)}
            </Form.Group>
            <Form.Group>
              {renderTextInput('birthdate', 'Date of Birth', props.formState.birthdate, isDOBDisabled || !isPrimaryInsuredOther, InputMaskDate)}
            </Form.Group>
            <Form.Group>
              {renderSelectInput('state', 'state', props.formState.state, States(), true, isStateDisabled || !isPrimaryInsuredOther)}
            </Form.Group>
            <Form.Group>
              {renderRadioInput('maritalStatus', MaritalStatusOptions, props.formState.maritalStatus)}
            </Form.Group>

            <Form.Group>
              {renderSelectInput('tobacco', 'Tobacco Use', props.formState.tobacco, TobaccoOptions)}
            </Form.Group>

            {isShowProposedInsuredEmailAndPhone &&
              <React.Fragment>
                <Form.Group>
                  {renderTextInput('proposedInsuredEmail', 'Email Address', props.formState.proposedInsuredEmail, isPIEmailDisabled)}
                </Form.Group>

                <Form.Group>
                  {renderTextInput('proposedInsuredPhone', 'Phone', props.formState.proposedInsuredPhone, isPIPhoneDisabled, InputMaskPhone)}
                </Form.Group>

              </React.Fragment>
            }
            {isMSEnableRelationshipToOwner && <Form.Group>
              {renderSelectInput('insuredRelationshipWithOwner', 'Relationship with owner', props.formState.insuredRelationshipWithOwner, InsuredRelationshipWithOwnerOptions, true, isInsuredRelationshipWithOwnerDisabled || !isPrimaryInsuredOther)}
            </Form.Group>
            }

            {isSurvivorshipPolicy &&
              <React.Fragment>
                <TitleComponent icon={NotesPagesNotification} title='Proposed Insured 2 Information' />
                <Form.Group>
                  {renderTextInput('secondaryInsuredFirstName', 'First Name', props.formState.secondaryInsuredFirstName, !isSecondaryInsuredOther)}
                </Form.Group>
                <Form.Group>
                  {renderTextInput('secondaryInsuredMiddleInitial', 'Middle Initial', props.formState.secondaryInsuredMiddleInitial, props.formState.secondaryInsuredMiddleNameDisabled)}
                </Form.Group>
                <Form.Group>
                  {renderTextInput('secondaryInsuredLastName', 'Last Name', props.formState.secondaryInsuredLastName, !isSecondaryInsuredOther)}
                </Form.Group>
                <Form.Group className="mb-1">
                  {renderRadioInput('secondaryInsuredGender', GenderOptions, props.formState.secondaryInsuredGender, '', !isSecondaryInsuredOther)}
                </Form.Group>
                <Form.Group>
                  {renderTextInput('secondaryInsuredBirthdate', 'Date of Birth', props.formState.secondaryInsuredBirthdate, !isSecondaryInsuredOther, InputMaskDate)}
                </Form.Group>
                <Form.Group>
                  {renderSelectInput('secondaryInsuredState', 'State', props.formState.secondaryInsuredState, States(), true, !isSecondaryInsuredOther)}
                </Form.Group>
                <Form.Group>
                  {renderRadioInput('secondaryInsuredMaritalStatus', MaritalStatusOptions, props.formState.secondaryInsuredMaritalStatus)}
                </Form.Group>

                <Form.Group>
                  {renderSelectInput('secondaryInsuredTobacco', 'Tobacco Use', props.formState.secondaryInsuredTobacco, TobaccoOptions)}
                </Form.Group>

                {isSecondaryInsuredOther &&
                  <React.Fragment>
                    <Form.Group>
                      {renderTextInput('secondaryInsuredEmail', 'Email Address', props.formState.secondaryInsuredEmail)}
                    </Form.Group>

                    <Form.Group>
                      {renderTextInput('secondaryInsuredPhone', 'Phone', props.formState.secondaryInsuredPhone, false, InputMaskPhone)}
                    </Form.Group>
                  </React.Fragment>
                }
                {isMSEnableRelationshipToOwner && <Form.Group>
                  {renderSelectInput('secondaryInsuredRelationshipWithOwner', 'Relationship with owner', props.formState.secondaryInsuredRelationshipWithOwner, InsuredRelationshipWithOwnerOptions, true, !isSecondaryInsuredOther)}
                </Form.Group>
                }
              </React.Fragment>
            }
          </Col>
        </Row>
        <BackNextButton onBack={props.onBack} />
      </form>
    </Container>
  )
}

InsuredBasicInfo.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
};

InsuredBasicInfo.ValidationSchema = (ageSpecs, isShowProposedInsuredEmailAndPhone, isSurvivorshipPolicy = false, isMSEnableRelationshipToOwner = false) => {
  return object().shape({
    proposedInsuredFirstName: customValidators.string().isValidNameLimitedSpecialChar('First Name is required.', true, false),
    proposedInsuredMiddleInitial: customValidators.string()
      .matches(/^[()!#&*+,.\/:;=?@^_`|~a-zA-ZÀ-ÖØ-öø-ÿ'-]{0,1}$/, 'Must be single and valid alpha character.').notRequired(),
    proposedInsuredLastName: customValidators.string().isValidNameLimitedSpecialChar('Last Name is required.', true, false),
    gender: string().required("Gender is required."),
    birthdate: customValidators.string().isValidateAgeAndDifferenceFromBirthdate('Invalid Date.', ageSpecs.min, ageSpecs.max,
      `This product is only available from age ${ageSpecs.min} to ${ageSpecs.max}.`),
    state: string().required("State is required."),
    maritalStatus: string().required("Marital Status is required."),
    tobacco: string().required("Tobacco is required."),
    proposedInsuredEmail: isShowProposedInsuredEmailAndPhone ? string().email('Email address must be valid.').required('Email address is required.')
      : string().notRequired(),
    proposedInsuredPhone: isShowProposedInsuredEmailAndPhone ? string().required('Phone Number is required.').matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, 'Phone must be formatted as (123) 456-7890')
      : string().notRequired(),
    insuredRelationshipWithOwner: isMSEnableRelationshipToOwner ? string().required('Relationship with owner is required.').nullable() : string().notRequired(),
    ...(isSurvivorshipPolicy && {
      secondaryInsuredFirstName: customValidators.string().isValidNameLimitedSpecialChar('First Name is required.', true, false),
      secondaryInsuredMiddleInitial: customValidators.string()
        .matches(/^[()!#&*+,.\/:;=?@^_`|~a-zA-ZÀ-ÖØ-öø-ÿ'-]{0,1}$/, 'Must be single and valid alpha character.').notRequired(),
      secondaryInsuredLastName: customValidators.string().isValidNameLimitedSpecialChar('Last Name is required.', true, false),
      secondaryInsuredGender: string().required("Gender is required."),
      secondaryInsuredBirthdate: customValidators.string().isValidateAgeAndDifferenceFromBirthdate('Invalid Date.', ageSpecs.min, ageSpecs.max,
        `This product is only available from age ${ageSpecs.min} to ${ageSpecs.max}.`),
      secondaryInsuredState: string().required("State is required."),
      secondaryInsuredMaritalStatus: string().required("Marital Status is required."),
      secondaryInsuredTobacco: string().required("Tobacco is required."),
      secondaryInsuredEmail: string().when('isSecondaryInsuredOther', {
        is: true,
        then: string().email('Email address must be valid.').required('Email address is required.'),
        otherwise: string().notRequired(),
      }),
      secondaryInsuredPhone: string().when('isSecondaryInsuredOther', {
        is: true,
        then: string().required('Phone Number is required.').matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, 'Phone must be formatted as (123) 456-7890'),
        otherwise: string().notRequired(),
      }),
      secondaryInsuredRelationshipWithOwner: isMSEnableRelationshipToOwner ? string().required('Relationship with owner is required.').nullable() : string().notRequired(),
    })
  });
};

InsuredBasicInfo.DefaultFormState = (prefill = false) => {
  return {
    proposedInsuredFirstName: prefill ? '' : '',
    proposedInsuredLastName: prefill ? '' : '',
    proposedInsuredMiddleInitial: prefill ? '' : '',
    gender: prefill ? '' : '',
    birthdate: prefill ? '' : '',
    state: prefill ? '' : '',
    maritalStatus: prefill ? '' : '',
    tobacco: prefill ? '' : '',
    proposedInsuredEmail: prefill ? '' : '',
    proposedInsuredPhone: prefill ? '' : '',
    insuredRelationshipWithOwner: prefill ? '' : '',
    isOther: true,
    secondaryInsuredFirstName: prefill ? '' : '',
    secondaryInsuredLastName: prefill ? '' : '',
    secondaryInsuredMiddleInitial: prefill ? '' : '',
    secondaryInsuredGender: prefill ? '' : '',
    secondaryInsuredBirthdate: prefill ? '' : '',
    secondaryInsuredState: prefill ? '' : '',
    secondaryInsuredMaritalStatus: prefill ? '' : '',
    secondaryInsuredTobacco: prefill ? '' : '',
    secondaryInsuredEmail: prefill ? '' : '',
    secondaryInsuredPhone: prefill ? '' : '',
    secondaryInsuredRelationshipWithOwner: prefill ? '' : '',
    isSecondaryInsuredOther: true,
  };
};



// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/BasicInfo/InsuredBasicInfo.js